/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCourseDocumentsId200,
  GetApiV1DocumentCourseDocumentsId401,
  GetApiV1DocumentCourseDocumentsId404,
  GetApiV1DocumentCourseDocumentsId500,
  GetApiV1DocumentCourseDocumentsIdPathParams,
  GetApiV1DocumentCourseDocumentsIdQueryResponse,
} from "../../types/documentCourseDocumentsController/GetApiV1DocumentCourseDocumentsId.ts";
import { courseDocumentsDetailViewModelSchema } from "../courseDocumentsDetailViewModelSchema.ts";

export const getApiV1DocumentCourseDocumentsIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1DocumentCourseDocumentsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCourseDocumentsId200Schema = z.lazy(
  () => courseDocumentsDetailViewModelSchema,
) as unknown as ToZod<GetApiV1DocumentCourseDocumentsId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseDocumentsId401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseDocumentsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1DocumentCourseDocumentsId404Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseDocumentsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCourseDocumentsId500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseDocumentsId500>;

export const getApiV1DocumentCourseDocumentsIdQueryResponseSchema = z.lazy(
  () => getApiV1DocumentCourseDocumentsId200Schema,
) as unknown as ToZod<GetApiV1DocumentCourseDocumentsIdQueryResponse>;
